import { useState, useCallback } from 'react'
import { PAGE_VIEW_EVENTS } from '@nsw-paginas-deslogadas/constants/analytics'
declare global {
    interface Window {
        dataLayer?: unknown[]
    }
}
type UseDataLayer = {
    // eslint-disable-next-line @typescript-eslint/ban-types
    track: (payload: Partial<{}>) => void
    setPageViewProps: (value: Partial<PageViewProps>) => void
}

export interface PushDataLayerProps {
    [key: string]: unknown
}

export interface PageViewProps {
    event: PAGE_VIEW_EVENTS
    brand: {
        id: string
        name: string
    }
    product: {
        name: string
        id: string
        category: string
    }
}

export function useDataLayer(): UseDataLayer {
    const [isTracked, setIsTracked] = useState(false)
    const track = useCallback(
        (payload: PushDataLayerProps) => {
            if (!isTracked) {
                if (!window.dataLayer) window.dataLayer = []
                window.dataLayer.push(payload)
                setIsTracked(true)
            }
        },
        [isTracked],
    )

    const setPageViewProps = useCallback(
        (value: Partial<PageViewProps>) => {
            return track({
                page: { path: window.location.pathname, title: window.document.title },
                ...value,
            })
        },
        [track],
    )

    return {
        track,
        setPageViewProps,
    }
}

export default useDataLayer
